<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import { Vue3Lottie } from 'vue3-lottie'
  import fingerprint from '@/shared/assets/animations/fingerprint.json'

  const modelValue = defineModel<boolean>()
  const FULL_FRAME = 151
  const HALF_FRAME = 75

  const root = ref<InstanceType<typeof Vue3Lottie> | null>(null)

  const playAnimation = (forward: boolean) => {
    if (!root.value) return

    if (forward) {
      root.value.setDirection('forward')
      root.value.playSegments([HALF_FRAME, FULL_FRAME], true)
    } else {
      root.value.setDirection('reverse')
      root.value.playSegments([FULL_FRAME, HALF_FRAME], true)
    }
  }

  const playFromStartToFrame = (frame: number) => {
    if (!root.value) return

    root.value.setDirection('forward')
    root.value.playSegments([0, frame], true)
  }

  watch(modelValue, (newVal) => {
    playAnimation(!!newVal)
  })

  const onLoaded = () => {
    if (modelValue.value) {
      playFromStartToFrame(FULL_FRAME)
    } else {
      playFromStartToFrame(HALF_FRAME)
    }
  }
</script>

<template>
  <div class="fingerprint-lottie">
    <Vue3Lottie
      ref="root"
      :animation-data="fingerprint"
      :width="120"
      :height="104"
      :autoplay="false"
      :loop="false"
      class="fingerprint-lottie__animation"
      @on-animation-loaded="onLoaded"
    />
  </div>
</template>

<style lang="scss" scoped>
  .fingerprint-lottie {
    position: relative;
    width: 60px;
    height: 52px;

    &__animation {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
